import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FileThumb } from 'components/misc'
import styles from './files-gallery.styl'

export default class FilesGallery extends Component {
  static propTypes = {
    urls: PropTypes.any
  }

  handleOpenFile = (fileUrl, type, fileName) => {
    const link = document.createElement('a')

    document.body.appendChild(link)
    link.download = fileName ? `${fileName}.${type}` : `${fileUrl}.${type}`
    link.href = fileUrl

    link.click()
  }

  render() {
    const { urls } = this.props

    if (!urls) {
      return null
    }

    return (
      <div className={styles.gallery}>
        {urls.map((item, index) => (
          <div key={index} className={styles.wrap}>
            <FileThumb
              className={styles.fileThumb}
              fileClassName={styles.file}
              nameClassName={styles.fileName}
              fileUrl={item}
              withCode
            />
          </div>
        ))}
      </div>
    )
  }
}
